class FormHandler {
  constructor() {
    this.forms = document.querySelectorAll('[data-form-type]')
    this.modal = null
    this.submittingForms = new WeakSet()
    this.init()
  }

  init() {
    import('./thank-you-modal.js').then(({ default: ThankYouModal }) => {
      this.modal = new ThankYouModal()
    })

    this.forms.forEach(form => {
      // Set formLoadedAt when form is first interacted with
      const setTimestamp = () => {
        const field = form.querySelector('input[name="formLoadedAt"]')
        if (field && !field.value) {
          field.value = String(Date.now())
        }
        form.removeEventListener('focus', setTimestamp, true)
      }
      form.addEventListener('focus', setTimestamp, true)

      // For touch/click on form elements
      form.addEventListener('click', () => {
        const field = form.querySelector('input[name="formLoadedAt"]')
        if (field && !field.value) {
          field.value = String(Date.now())
        }
      }, { once: true })

      form.addEventListener('submit', (e) => this.handleSubmit(e))
    })
  }

  async handleSubmit(e) {
    e.preventDefault()
    const form = e.target

    // Prevent duplicate submission
    if (this.submittingForms.has(form) || form.dataset.submitting === 'true') {
      return
    }

    // Anti-bot client-side: if honeypot is filled, silently abort
    const honeypot = form.querySelector('input[name="website"]')
    if (honeypot && honeypot.value.trim()) {
      return
    }

    // Ensure formLoadedAt is set before sending
    const loadedAtField = form.querySelector('input[name="formLoadedAt"]')
    if (loadedAtField && !loadedAtField.value) {
      loadedAtField.value = String(Date.now())
    }

    this.submittingForms.add(form)
    form.dataset.submitting = 'true'
    const formType = form.dataset.formType
    const formData = new FormData(form)
    const data = { formType }

    for (const [key, value] of formData.entries()) {
      data[key] = typeof value === 'string' ? value.trim() : value
    }

    // Ensure boletin_suscrito is explicitly boolean
    if (!('boletin_suscrito' in data)) data.boletin_suscrito = false
    else data.boletin_suscrito = true

    // Map GDPR checkbox to backend field
    if (data.politicas) data.politicas_aceptadas = true

    if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      this.showError(form, 'Email no v\u00e1lido')
      return
    }

    data.timestamp = new Date().toISOString()

    const submitBtn = form.querySelector('button[type="submit"]')
    const originalHTML = submitBtn?.innerHTML

    if (submitBtn) {
      submitBtn.disabled = true
      submitBtn.innerHTML = '<i class="ph ph-spinner text-xl animate-spin"></i> Enviando...'
    }

    try {
      const response = await fetch('/handleForm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })

      const result = await response.json()

      if (response.ok && result.success) {
        form.reset()
        if (this.modal) {
          const name = data.firstName || data.name || ''
          this.modal.show(formType, name)
        }
      } else if (response.status === 429) {
        this.showError(form, 'Demasiados intentos. Espera un momento e int\u00e9ntalo de nuevo.')
      } else {
        this.showError(form, result.error || 'Error al enviar. Int\u00e9ntalo de nuevo.')
      }
    } catch (error) {
      this.showError(form, 'Error de conexión. Verifica tu conexión e inténtalo de nuevo.')
    } finally {
      this.submittingForms.delete(form)
      delete form.dataset.submitting
      if (submitBtn) {
        submitBtn.disabled = false
        submitBtn.innerHTML = originalHTML
      }
    }
  }

  showError(form, message) {
    const submitBtn = form.querySelector('button[type="submit"]')
    if (submitBtn) {
      const originalHTML = submitBtn?.dataset?.originalHtml || submitBtn?.innerHTML
      if (originalHTML && !submitBtn.dataset.originalHtml) {
        submitBtn.dataset.originalHtml = originalHTML
      }
      submitBtn.innerHTML = `<i class="ph ph-warning-circle text-xl"></i> ${message}`
      submitBtn.classList.add('bg-red-500')
      setTimeout(() => {
        submitBtn.innerHTML = submitBtn.dataset.originalHtml || originalHTML
        submitBtn.classList.remove('bg-red-500')
        delete submitBtn.dataset.originalHtml
      }, 4000)
    }
  }
}

export default FormHandler